import { useEffect } from "react";

export const SITE_ORIGIN = "https://qsslj.cn";
export const SITE_NAME = "瓜田爆料";

interface SeoOptions {
  title: string;
  description: string;
  keywords: string[];
  path: string;
  ogType?: string;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
}

function upsertMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel: string, href: string) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function useSeo({ title, description, keywords, path, ogType = "website", jsonLd }: SeoOptions) {
  useEffect(() => {
    const canonical = `${SITE_ORIGIN}${path === "/" ? "" : path}`;
    document.title = title;

    upsertMeta("name", "description", description);
    upsertMeta("name", "keywords", keywords.join(","));
    upsertMeta("name", "robots", "index,follow,max-image-preview:large");

    upsertMeta("property", "og:type", ogType);
    upsertMeta("property", "og:site_name", SITE_NAME);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", canonical);
    upsertMeta("property", "og:locale", "zh_CN");

    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);

    upsertLink("canonical", canonical);

    let script = document.getElementById("gt-jsonld") as HTMLScriptElement | null;
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "gt-jsonld";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.textContent = "";
    }
  }, [title, description, keywords, path, ogType, jsonLd]);
}